import { render, staticRenderFns } from "./Loa.vue?vue&type=template&id=78888ed9&"
import script from "./Loa.vue?vue&type=script&lang=js&"
export * from "./Loa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('78888ed9')) {
      api.createRecord('78888ed9', component.options)
    } else {
      api.reload('78888ed9', component.options)
    }
    module.hot.accept("./Loa.vue?vue&type=template&id=78888ed9&", function () {
      api.rerender('78888ed9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Input/Loa.vue"
export default component.exports